import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "externe_link",
  "use": "externe_link-usage",
  "viewBox": "0 0 1094 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1094 512\" id=\"externe_link\"><path class=\"st0\" d=\"M0 219.5h729.8C675.1 136.6 615.4 74 612.7 0 737 127.4 898.6 193.7 1094 256.1 898.6 315.7 744 388.4 612.7 512c8.5-80.3 61.7-131.2 117.1-219.4H0v-73.1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./sv_cms/static/assets/images/icons/externe_link.svg
// module id = 289
// module chunks = 6